/** Energy — electricity flow Sankey /energy/electricity-sankey (electricitySankey.vue) */
export default {
  electricitySankey: {
    filterQueryDate: 'Date',
    phPickDate: 'Pick a date',
    filterTenantScope: 'Tenants',
    phTenant: 'Select tenants',
    btnQuery: 'Query',
    btnReset: 'Reset',
    btnSelectAll: 'Select all',
    btnDeselectAll: 'Clear selection',
    moreActions: 'More',
    exportChart: 'Export chart',
    exportData: 'Export data',
    cardTotalElec: 'Total usage',
    cardTotalElecTip: 'Sum of selected tenants for the day',
    vsYesterday: 'vs yesterday',
    cardTenantCount: 'Tenants',
    unitTenants: ' tenants',
    activeTenants: 'Selected',
    cardAvgElec: 'Average',
    unitKwhPerTenant: 'kWh / tenant',
    dailyPerTenant: 'Per tenant per day',
    cardDistribution: 'Breakdown',
    byTypeDistribution: 'By category',
    distBarTitle: '{name}: {value} kWh ({pct}%)',
    loading: 'Loading...',
    chartTitle: 'Electricity flow',
    chartSubtitle: 'Tenant distribution — {date}',
    tipDragChart: 'Tip: drag to pan the chart',
    viewSankey: 'Sankey',
    viewTree: 'Tree',
    pickerYesterday: 'Yesterday',
    pickerDayBefore: 'Day before',
    pickerMondayThisWeek: 'Monday this week',
    msgTenantListFail: 'Failed to load tenants',
    msgPickDate: 'Please select a date',
    msgPickTenant: 'Please select at least one tenant',
    msgFetchFail: 'Failed to load data',
    msgExportDeveloping: 'Data export is not available yet',
    tooltipElecLine: 'Usage: {value} kWh',
    tooltipFlowLine: '{from} → {to}',
    toolboxRestore: 'Reset',
    toolboxSaveImage: 'Save as image',
    exportPngName: 'electricity_sankey_{date}.png',
    nodePrivate: 'Dedicated equipment',
    nodeShare: 'Shared equipment',
    defaultTotalName: 'Site total',
    shareDeviceTitle: '{name} (allocated)',
    abbrTenThousand: 'w',
    abbrThousand: 'k'
  }
}
